<template>
  <div class="no-data">
    <van-icon name="bar-chart-o"/>
    <span class="text">{{ mes }}</span>
  </div>
</template>

<script>
export default {
  name: "noData",
  props: {
    mes: String
  }
}
</script>

<style scoped lang="less">
  .no-data{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px;
    .van-icon{
      color: @font9;
      font-size: 40px;
    }
    .text{
      color: @font9;
      margin-top: 10px;
    }
  }
</style>